<template>
  <v-dialog :value="true" max-width="500">
    <v-card>
      <v-card-title class="headline">Editar Configurações</v-card-title>
      <v-card-text class="pt-4">
        <v-alert type="error" v-if="errorMessage" class="mb-6">{{ errorMessage }}</v-alert>
        <v-form ref="form" @submit.prevent>
          <v-text-field
            label="Código do estatuto"
            v-model="fields.document.value"
            :rules="[...fields.document.rules]"
            outlined dense
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="default" :disabled="saving" text @click="$emit('canceled')">
          Cancelar
        </v-btn>
        <v-btn color="success" :disabled="saving" :loading="saving" text @click="saveItem()">
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'documentModal',
  props: {
    settings: {
      required: true,
      type: Object
    },
    celebrationId: {
      required: true,
      type: String
    }
  },
  data: () => ({
    saving: false,
    fields: {
      document: {
        value: null,
        rules: [
          v => !!v || 'O código do estatuto é obrigatório'
        ]
      }
    },
    errorMessage: null
  }),
  computed: {
    apiData () {
      let data = {}
      for (let key in this.fields) {
        if (this.fields[key].value) data[key] = this.fields[key].value
      }
      return data
    }
  },
  methods: {
    ...mapMutations(['SET_SNACKBAR']),
    saveItem () {
      this.saving = true
      this.$firestore.collection('settings').doc(this.celebrationId).set({ ...this.apiData }, { merge: true })
        .then(() => {
          this.SET_SNACKBAR({ text: 'Estatuto atualizado' })
          this.$emit('ok')
        })
        .catch(() => {
          this.errorMessage = 'Houve um erro ao processar seu pedido, por favor tente novamente'
        })
        .finally(() => {
          this.saving = false
        })
    }
  },
  created () {
    if (!this.celebrationId) {
      this.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
      this.$emit('canceled')
    }

    for (let key in this.fields) {
      if (this.settings && this.settings[key]) this.fields[key].value = this.settings[key]
      else this.fields[key].value = ''
    }
  }
}
</script>
